/**
 * @format
 */
import { api } from '@/scripts/api';

export const MDFClientRequestService = {
    post(accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/client-account/${accountId}/requests`;

            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    delete(accountId, requestId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/client-account/${accountId}/requests/${requestId}`;

            api.delete(service).then(resolve).catch(reject);
        });
    },

    getRequestById(requestId, clientAccountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/client-account/${clientAccountId}/requests/${requestId}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    submitPop(requestId, clientAccountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/client-account/${clientAccountId}/requests/${requestId}/pop-submit`;
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    editPop(requestId, clientAccountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/client-account/${clientAccountId}/requests/${requestId}/pop-submit`;
            api.put(service, payload).then(resolve).catch(reject);
        });
    },
};
